import MobileFooter from '../../components/Mobile/MobileFooter';

const MobileOrders = () => {
  return (
      <div>
        <h1>MobileOrders</h1>
        <MobileFooter/>
      </div>
  );
};

export default MobileOrders;